import React from 'react';

export default class HtmlComponent extends React.Component {
    render(){
        return (<div className="dangerous-html" dangerouslySetInnerHTML={{__html: this.props.html}} />);
    }
}